var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOption1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "4px",
    viewBox: "0 0 18 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "44A98423-CA36-42AE-BB19-F716DF5F67BB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 3.59231961 0 3.59231961 3.59231503 0 3.59231503"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 3.59563951 0 3.59563951 3.59228427 0 3.59228427"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Admin",
    transform: "translate(-380.000000, -1846.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option",
    transform: "translate(380.000000, 1846.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.55004684 C0.0879240348,1.21504781 0.209295133,0.899916235 0.438087844,0.627689896 C1.14269542,-0.210705934 2.47502988,-0.209966188 3.16690326,0.636831037 C4.07155915,1.74401867 3.46961768,3.3417104 2.0591344,3.57710799 C1.1506741,3.72875581 0.230272202,3.08184838 0.0358248171,2.15579271 C0.0277404557,2.11711459 0.0121001226,2.08007448 0,2.04224178 C0,1.8781768 0,1.71411182 0,1.55004684",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(7.204101, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79024195,-4.81387581e-06 C2.782452,-0.00227207542 3.59009556,0.800034742 3.59231961,1.79023691 C3.59458687,2.78244697 2.79238573,3.589932 1.80207788,3.59231503 C0.809973507,3.59468751 0.00238279278,2.79238069 0,1.80207284 C-0.00231987495,0.809968468 0.800092621,0.00227207542 1.79024195,-4.81387581e-06",
    id: "Fill-3",
    fill: "#000000",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(14.404360, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1.79486032 C0.000793169599,0.803548533 0.805583419,2.64194816e-05 1.79768779,-2.64194816e-05 C2.78445543,-2.64194816e-05 3.59622042,0.811527217 3.59563951,1.79744943 C3.59505797,2.78337165 2.78255323,3.59328728 1.79509868,3.59228427 C0.803681216,3.59133223 -0.000791999298,2.78580224 0,1.79486032",
    id: "Fill-6",
    fill: "#000000",
    mask: "url(#mask-4)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption1);
export default __webpack_public_path__ + "static/media/Option-1.217742be78d87764db8523978a137354.svg";
export { ForwardRef as ReactComponent };